import { Injectable, inject } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { CrudService } from "./crud.service";
import { Clients } from "../models/clients";
import { Company } from "../models/company";

@Injectable({
  providedIn: "root",
})
export class CompanyService extends CrudService<Company, string> {
  protected _http: HttpClient;

  constructor() {
    const _http = inject(HttpClient);

    super(_http, `${environment.baseUrl}/company`);

    this._http = _http;
  }
}
